import React, { useState } from 'react'
import Header from '../../components/application/application/header'
import ApplicationContent from '../../components/application/application'

function Application() {
  // Manage shared search state at the container level
  const [searchTerm, setSearchTerm] = useState('');
  const [showSearchModal, setShowSearchModal] = useState(false);

  return (
    <>
      <Header
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        showSearchModal={showSearchModal}
        setShowSearchModal={setShowSearchModal}
      />
      <ApplicationContent
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        showSearchModal={showSearchModal}
        setShowSearchModal={setShowSearchModal}
      />
    </>
  )
}

export default Application